// TournamentLobby.jsx
import React, { useEffect, useState,useRef,useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import tournamentSocket from './tournamentSocket';
import KnockoutScoreboard from './KnockoutScoreboard';
import SpinWheelOverlay from './SpinWheelOverlay';
import { useTournamentSocket } from './hooks/useTournamentSocket';
import TournamentPaymentModal from './components/TournamentPaymentModal';
import longTournamentSocket, { ensureLongSocket } from './longTournamentSocket';
import { useSound } from './sfx/SoundProvider'; // ← добавь

function TournamentLobby({ username, typeGame,rightSlot,ratingSlot,refreshTick = 0,refreshShortTables,
  refreshLongTables,  tournaments: shortFromParent = [],highlight = false, }) {
 
  const navigate = useNavigate();
  const { t: translate } = useTranslation();

    // 👇 ДОБАВЛЯЕМ: детект мобильного
  const isMobile = window.innerWidth <= 1000;

  const [tournaments, setTournaments] = useState([]);
  const [myUserId, setMyUserId] = useState(null);
  const [showBracketForId, setShowBracketForId] = useState(null);
  const [wheelData, setWheelData] = useState(null);   // {angle, prize, buyIn}
  const [showWheel, setShowWheel]   = useState(false);
  const tournamentSocket = useTournamentSocket();
  const [redirectData, setRedirectData] = useState(null);
  const connectAskRef = useRef(null);
  const connectRef = useRef(null);
  const hasCheckedMatchRef = useRef(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const askedOnceRef = useRef(false);
  const [allTournaments, setAllTournaments] = useState([]);
  const [longTournaments, setLongTournaments] = useState([])
  const [payOpen, setPayOpen] = useState(false);
  const { play } = useSound();   
  // 1) Подключаемся к /tournament
  // useEffect(() => {
  //   if (!tournamentSocket.connected) {
  //     tournamentSocket.connect();
  //   }
  //   tournamentSocket.emit('requestAllTournaments');
  // }, []);

const STATUS_ORDER = { registration: 0, creating_semifinal: 1, semifinal: 2, creating_final: 3, final: 4 };

// троттлим повторные запросы чтобы не спамить
const lastShortAskRef = useRef(0);


const handleRegisterClick = () => setPayOpen(true);
const handlePayClose = () => setPayOpen(false);


const onePerTier = (arr) => {
  // Группируем по buy-in, игнорируя завершённые и лишние buy-in
  const byBuy = new Map();
  for (const t of arr) {
    // const buy = Number(t.buyIn ?? t.buy_in ?? 0);
    // if (!ALLOWED_TIERS.has(buy)) continue;
    const buy = Number(t.buyIn ?? t.buy_in ?? 0);
    const status = String(t.status).toLowerCase();
    if (status === 'finished') continue;
    if (!byBuy.has(buy)) byBuy.set(buy, []);
    byBuy.get(buy).push(t);
  }





  const ts = (t) => {
  const d = Date.parse(t.updatedAt || t.updated_at || t.createdAt || t.created_at || '');
  return Number.isFinite(d) ? d : 0;
};
const newerId = (a, b) => {
  const na = Number(a.id), nb = Number(b.id);
  if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
  return String(a.id).localeCompare(String(b.id));
};
const rank = (t) => STATUS_ORDER[String(t.status).toLowerCase()] ?? -1;

const pickForBuyIn = (list) => {
  if (!list.length) return null;

  // 1) самые свежие по времени
  const maxTs = Math.max(...list.map(ts));
  const freshest = list.filter(t => ts(t) === maxTs);

  // 2) среди самых свежих, если есть регистрация — берём её
  const freshReg = freshest.find(t => String(t.status).toLowerCase() === 'registration');
  if (freshReg) return freshReg;

  // 3) иначе — максимальная стадия среди самых свежих
  const bestRank = Math.max(...freshest.map(rank));
  const top = freshest.filter(t => rank(t) === bestRank);

  // 4) при равенстве — самый новый по id
  return top.sort((a, b) => newerId(b, a))[0];
};


const onePerTier = (arr) => {
  const byBuy = new Map();
  for (const t of arr) {
    const st = String(t.status).toLowerCase();
    if (st === 'finished') continue;                 // завершённые скрываем
    const buy = Number(t.buyIn ?? t.buy_in ?? 0);
    (byBuy.get(buy) ?? byBuy.set(buy, []).get(buy)).push(t);
  }
  const picked = [];
  for (const [, list] of byBuy) {
    const p = pickForBuyIn(list);
    if (p) picked.push(p);
  }
  return picked.sort((x, y) => (Number(y.buyIn ?? y.buy_in) - Number(x.buyIn ?? x.buy_in)));
};

  // const pickForBuyIn = (list) => {
  //   // 1) Если есть турниры в регистрации — берём самый новый по id
  //   const regs = list.filter(t => String(t.status).toLowerCase() === 'registration');
  //   if (regs.length) {
  //     return regs.reduce((best, cur) =>
  //       Number(cur.id) > Number(best.id) ? cur : best
  //     );
  //   }

  //   // 2) Иначе — берём самый «поздний» по STATUS_ORDER, при равенстве — больший id
  //   return list.reduce((best, cur) => {
  //     const a = STATUS_ORDER[String(cur.status).toLowerCase()] ?? -1;
  //     const b = STATUS_ORDER[String(best.status).toLowerCase()] ?? -1;
  //     if (a !== b) return a > b ? cur : best;
  //     return Number(cur.id) > Number(best.id) ? cur : best;
  //   });
  // };

  const picked = [];
  for (const [buy, list] of byBuy.entries()) {
    picked.push(pickForBuyIn(list));
  }

  // Сортируем по buy-in убыванию
  return picked.sort(
    (x, y) => (Number(y.buyIn ?? y.buy_in) - Number(x.buyIn ?? x.buy_in))
  );
};


// const onePerTier = (arr) => {
//   const map = new Map(); // buyIn -> лучший турнир
//   for (const t of arr) {
//     const buy = Number(t.buyIn ?? t.buy_in ?? 0);
//     if (!ALLOWED_TIERS.has(buy)) continue;
//     if (String(t.status).toLowerCase() === 'finished') continue;

//     const prev = map.get(buy);
//     if (!prev) { map.set(buy, t); continue; }

//     const a = STATUS_ORDER[String(t.status).toLowerCase()] ?? 99;
//     const b = STATUS_ORDER[String(prev.status).toLowerCase()] ?? 99;

//     if (a < b || (a === b && Number(t.id) > Number(prev.id))) {
//       map.set(buy, t);
//     }
//   }
//   // сортируем по buyIn убыв.
//   return Array.from(map.values()).sort(
//     (x, y) => (Number(y.buyIn ?? y.buy_in) - Number(x.buyIn ?? x.buy_in))
//   );
// };



const CARD_BG = {
  1:  '/1.png',
  5:  '/5.png',
  10: '/10.png',
  20: '/20.png',   // ← добавили 20
  50: '/50.png',   // на будущее (только верхний баннер)
};

// --- какие buy‑in показываем внизу и в каком порядке ---
const BOTTOM_TIERS = [1, 5, 10, 20];
const ALLOWED_TIERS = new Set([1, 5, 10, 20, 50]);

const MAX_BY_BUYIN = {
  1: 100,
  5: 500,
  10: 1000,
  20: 2000,
  50: 5000, // это только для верхнего баннера
};

// const getMaxAmount = (t) => {
//   const buy = Number(t.buyIn ?? t.buy_in ?? 0);
//   if (buy === 1) return 100;
//   const prize = Number(t.prize ?? t.maxPrize ?? t.max_prize ?? 0);
//   const mapped = MAX_BY_BUYIN[buy];
//   return prize || mapped || (buy > 0 ? buy * 100 : 0);
// };
const getMaxAmount = (t) => {
  const buy = Number(t.buyIn ?? t.buy_in ?? 0);
  return MAX_BY_BUYIN[buy] ?? (buy > 0 ? buy * 100 : 0);
};

const pickImg = (t, featured) => {
  const buyInNum = Number(t.buyIn ?? t.buy_in ?? 0);
  const hero = t.bannerUrl || '/BigTournament.png';
  const mini = t.bgUrl || CARD_BG[buyInNum] || '/img/blok.png'; // ← фолбэк НЕ герой
  return featured ? hero : mini;
};


const isUserRegistered = (t, username) => {
  if (!Array.isArray(t.registeredPlayers)) return false;
  return t.registeredPlayers.some(p =>
    (typeof p === 'string' ? p === username : p?.username === username)
  );
};



useEffect(() => {
  console.log('[TL] mount', { typeGame, socketConnected: !!tournamentSocket.connected });
  return () => console.log('[TL] unmount');
}, []);

  useEffect(() => {
    if (!refreshTick) return;

    const emitReq = () => {
      console.log('[TL] refreshTick=', refreshTick, '→ emit requestAllTournaments');
      lastShortAskRef.current = 0;
      tournamentSocket.emit('requestAllTournaments');
      // если надо ещё и длинные по второму сокету:
      // longTournamentSocket.emit('requestAllTournaments');
    };

    if (tournamentSocket?.connected) emitReq();
    else tournamentSocket.once('connect', emitReq);

    // опционально — таймаут-диагностика, если не придёт ответ
    const t = setTimeout(() => {
      console.warn('[TL] no tournaments after refreshTick within 1500ms');
    }, 1500);
    return () => clearTimeout(t);
  }, [refreshTick, tournamentSocket]);

useEffect(() => {
  // ДЛИННЫЕ:
  // 1) сначала используем отдельный список /long-tournament;
  // 2) если он почему-то пустой, берём длинные турниры из общего
  //    списка /tournament, который Lobby/TournamentLobby уже получил.
  //
  // Это убирает зависимость отображения карточек от второго сокета
  // и возвращает long-джекпоты даже если /long-tournament не ответил.
  const longFallback = Array.isArray(allTournaments)
    ? allTournaments.filter(
        (t) => String(t?.gameType || '').toLowerCase() === 'long'
      )
    : [];

  const base =
    typeGame === 1
      ? (
          Array.isArray(longTournaments) && longTournaments.length > 0
            ? longTournaments
            : longFallback
        )
      : allTournaments;

  console.log('[TL] cards source', {
    typeGame,
    longDirect: Array.isArray(longTournaments) ? longTournaments.length : 0,
    longFallback: longFallback.length,
    all: Array.isArray(allTournaments) ? allTournaments.length : 0,
    selected: Array.isArray(base) ? base.length : 0,
  });

  setTournaments(onePerTier(base || []));
}, [typeGame, longTournaments, allTournaments]);




useEffect(() => {
  let got = false;
  const mark = () => { got = true; };
  tournamentSocket.on('responseAllTournaments', mark);

  const t = setTimeout(() => {
    if (!got) console.warn('[TL] no tournaments within 1500ms (short ns). connected=', tournamentSocket.connected);
  }, 1500);

  return () => { clearTimeout(t); tournamentSocket.off('responseAllTournaments', mark); };
}, [tournamentSocket]);


useEffect(() => {
  const onCreatedViaShort = (t) => {
    if (!t) return;
    if (t.gameType !== 'long') return;
    if (!ALLOWED_TIERS.has(Number(t.buyIn ?? t.buy_in))) return;
    setLongTournaments(prev => {
      const i = prev.findIndex(x => x.id === t.id);
      return i === -1 ? [t, ...prev] : prev.map(x => x.id === t.id ? { ...x, ...t } : x);
    });
  };

  tournamentSocket.on('tournament_created', onCreatedViaShort);
  tournamentSocket.on('long_tournament_created', onCreatedViaShort);

  return () => {
    tournamentSocket.off('tournament_created', onCreatedViaShort);
    tournamentSocket.off('long_tournament_created', onCreatedViaShort);
  };
}, [tournamentSocket]);


useEffect(() => {
  if (!username) return;
  ensureLongSocket(username);

  const ask = () => {
    console.log('[LONG] emit requestAllTournaments');
    longTournamentSocket.emit('requestAllTournaments');
  };

// const onAll = (all) => {
//   const arr = Array.isArray(all)
//     ? all.filter(t => ALLOWED_TIERS.has(Number(t.buyIn ?? t.buy_in)))
//     : [];
//   console.log('[LONG] responseAllTournaments:', arr.length);
//   setLongTournaments(arr);
// };

const onAll = (all) => {
  const arr = Array.isArray(all)
    ? all.filter(t => ALLOWED_TIERS.has(Number(t.buyIn ?? t.buy_in)))
    : [];
  console.log('[LONG] responseAllTournaments:', arr.length);
  console.table(arr.map(t => ({
    id: t.id,
    buyIn: Number(t.buyIn ?? t.buy_in),
    status: String(t.status).toLowerCase(),
    gameType: t.gameType
  })));
  setLongTournaments(arr);
};


const onCreated = (t) => {
  if (!t) return;
  if (!ALLOWED_TIERS.has(Number(t.buyIn ?? t.buy_in))) return;

  console.log('[LONG] tournament_created:', t.id, t.status, t.buyIn);
  setLongTournaments(prev => {
    const i = prev.findIndex(x => x.id === t.id);
    return i === -1 ? [t, ...prev] : prev.map(x => x.id === t.id ? { ...x, ...t } : x);
  });
};



 longTournamentSocket.on('connect', ask);
 if (longTournamentSocket.connected) ask();
  longTournamentSocket.on('responseAllTournaments', onAll);
  longTournamentSocket.on('tournament_created', onCreated);
  longTournamentSocket.on('long_tournament_created', onCreated);


  return () => {
    longTournamentSocket.off('connect', ask);
    longTournamentSocket.off('responseAllTournaments', onAll);
   longTournamentSocket.off('tournament_created', onCreated);
   longTournamentSocket.off('long_tournament_created', onCreated); // ← ДОБАВИТЬ
 };
}, [username]);

// (опционально) подстраховочный опрос, пока ты проверяешь
// useEffect(() => {
//   if (typeGame !== 1) return;
//  const id = setInterval(() => {
//    longTournamentSocket.emit('requestAllTournaments');
//  }, 5000);
//   return () => clearInterval(id);
// }, [typeGame]);



useEffect(() => {
  if (typeGame !== 1 && Array.isArray(shortFromParent)) {
    // ВАЖНО:
    // раньше здесь allTournaments полностью заменялся shortFromParent.
    // Из-за этого после ухода с вкладки ДЛИННЫЕ терялись long-турниры,
    // и при возврате fallback уже не мог их найти.
    //
    // Теперь обновляем short-часть, но сохраняем ранее полученные long.
    setAllTournaments((prev) => {
      const prevLong = Array.isArray(prev)
        ? prev.filter(
            (t) => String(t?.gameType || '').toLowerCase() === 'long'
          )
        : [];

      const nextShort = shortFromParent.filter(
        (t) => String(t?.gameType || '').toLowerCase() !== 'long'
      );

      return [...nextShort, ...prevLong];
    });
  }
}, [typeGame, shortFromParent]);




// Когда пользователь возвращается со стола (окно/вкладка в фокусе) — дёрнуть короткие турниры
useEffect(() => {
  if (!tournamentSocket) return;

  const askShort = () => {
    // только для «коротких» (typeGame !== 1) и не чаще раза в 1.5с
    if (typeGame === 1) return;
    const now = Date.now();
    if (now - lastShortAskRef.current < 1500) return;
    lastShortAskRef.current = now;
    tournamentSocket.emit('requestAllTournaments');
  };

  const onVisibility = () => {
    if (document.visibilityState === 'visible') askShort();
  };

  window.addEventListener('focus', askShort);
  document.addEventListener('visibilitychange', onVisibility);

  return () => {
    window.removeEventListener('focus', askShort);
    document.removeEventListener('visibilitychange', onVisibility);
  };
}, [tournamentSocket, typeGame]);




// Если открыли «Короткие», а списка нет — запросить
useEffect(() => {
  if (typeGame === 1) return; // только короткие
  if ((tournaments?.length ?? 0) > 0) return;

  const now = Date.now();
  if (now - lastShortAskRef.current < 1500) return;
  lastShortAskRef.current = now;
  tournamentSocket.emit('requestAllTournaments');
}, [typeGame, tournaments?.length, tournamentSocket]);







useEffect(() => {
  const handleNewTournamentCreated = () => {
    console.log('[Client] Получен tournament_newCreated → перезапрашиваем турниры');
const now = Date.now();
   if (!tournamentSocket._lastTournamentRequest ||
       now - tournamentSocket._lastTournamentRequest > 1500) {
     tournamentSocket._lastTournamentRequest = now;
     // даём серверу снять старые записи и создать новые
     setTimeout(() => {
       try { tournamentSocket.emit('requestAllTournaments'); } catch {}
     }, 800);
   } else {
     console.log('[Client] emit requestAllTournaments — пропущен (слишком часто)');
   }
  //   const now = Date.now();
  //   if (
  //     !tournamentSocket._lastTournamentRequest ||
  //     now - tournamentSocket._lastTournamentRequest > 3000
  //   ) {
  //     tournamentSocket._lastTournamentRequest = now;

  //     // ⏱ Ждём 1 секунду, чтобы сервер успел удалить старый турнир
  //     // setTimeout(() => {
  //     //   tournamentSocket.emit('requestAllTournaments');
  //     // }, 1000);

  //   } else {
  //     console.log('[Client] emit requestAllTournaments — пропущен (слишком часто)');
  //   }
  };

  tournamentSocket.on('tournament_newCreated', handleNewTournamentCreated);
  return () => tournamentSocket.off('tournament_newCreated', handleNewTournamentCreated);
}, [tournamentSocket]);









useEffect(() => {
  function handleSpinWheel({ angle, prize, buyIn }) {
    setWheelData({ angle, prize, buyIn });
    setShowWheel(true);
  }
  tournamentSocket.on('spinWheel', handleSpinWheel);
  return () => tournamentSocket.off('spinWheel', handleSpinWheel);
}, []);



useEffect(() => {
  document.body.classList.add('tl-hide-bottom');
  return () => document.body.classList.remove('tl-hide-bottom');
}, []);






useEffect(() => {
const ask = () => {
    if (!askedOnceRef.current) {
      askedOnceRef.current = true;
      console.log('[CLIENT] requestAllTournaments');
      tournamentSocket.emit('requestAllTournaments');
    }
  };

  // const handle = (all) => {
  //   // В режиме КОРОТКИХ и если родитель уже дал список — НЕ затираем его
  //   if (typeGame !== 1 && (shortFromParent?.length ?? 0) > 0) return;
  //   console.log('[TournamentLobby] получены турниры:', all?.length ?? 0);
  //   setAllTournaments(Array.isArray(all) ? all : []);
  // };
const handle = (all) => {
  // если мы на КОРОТКИХ и родитель уже дал список — не затираем его пустым ответом,
  // но непустой — принимаем
  if (
    typeGame !== 1 &&
    (shortFromParent?.length ?? 0) > 0 &&
    !(Array.isArray(all) && all.length > 0)
  ) {
    return;
  }
  console.log('[TournamentLobby] получены турниры:', all?.length ?? 0);
  setAllTournaments(Array.isArray(all) ? all : []);
};


  tournamentSocket.on('connect', ask);
  if (tournamentSocket.connected) ask();
  tournamentSocket.on('responseAllTournaments', handle);

  return () => {
    tournamentSocket.off('connect', ask);
    tournamentSocket.off('responseAllTournaments', handle);
  };
// важны зависимости — чтобы проверка shortFromParent работала корректно
}, [tournamentSocket, typeGame, shortFromParent?.length]);

// useEffect(() => {
//   const ask = () => {
//     if (!askedOnceRef.current) {
//       askedOnceRef.current = true;            // эмитим только один раз на этот mount
//       console.log('[CLIENT] requestAllTournaments');
//       tournamentSocket.emit('requestAllTournaments');
//     }
//   };

//   const handle = (all) => {
//     console.log('[TournamentLobby] получены турниры:', all?.length ?? 0);
//     setAllTournaments(Array.isArray(all) ? all : []);
//   };

//   tournamentSocket.on('connect', ask);
//   if (tournamentSocket.connected) ask();
//   tournamentSocket.on('responseAllTournaments', handle);

//   return () => {
//     tournamentSocket.off('connect', ask);
//     tournamentSocket.off('responseAllTournaments', handle);
//   };
// }, [tournamentSocket]);          // ⬅️ только сокет в зависимостях



useEffect(() => {
  const user = username || localStorage.getItem('username');
  if (!user) return;

  // Чтобы сработало только один раз
  if (hasCheckedMatchRef.current) return;
  hasCheckedMatchRef.current = true;

  const check = () => {
    tournamentSocket.emit(
      'tournament_checkActiveMatch',
      { userName: user },
      (res) => {
        console.log('[DEBUG] Ответ от tournament_checkActiveMatch:', res);

        if (!res) return;
        if (res.gameStatus === 'finished') return;
        if (!(res.inSemiFinal || res.inFinal)) return;
        if (!res.tableId || !res.gameId || !res.gameType) return;

        // 👇 Сохраняем и в состояние, и в локал
        setRedirectData({
          tableId: res.tableId,
          gameId: res.gameId,
          gameType: res.gameType,
        });

        localStorage.setItem('tableId', String(res.tableId));
        localStorage.setItem('gameType', res.gameType);
      }
    );
  };

  if (tournamentSocket.connected) {
    check();
  } else {
    tournamentSocket.once('connect', check);
  }

  return () => {
    tournamentSocket.off('connect', check);
  };
}, [username, tournamentSocket]);


  // 3) Определяем userId
  useEffect(() => {
    if (!username) return;
    tournamentSocket.emit('tournament_getUserIdByName', username, (res) => {
      if (res.success) {
        setMyUserId(res.userId);
        localStorage.setItem('userId', String(res.userId));
      }
    });
  }, [username]);













useEffect(() => {
  function handleSemifinalsStarted({ tournamentId, gameType, semifinalTables, isFinal }) {
    console.log(`[client] handleSemifinalsStarted →`, {
      tournamentId,
      gameType,
      semifinalTables,
      isFinal,
    });
const found = semifinalTables.find((m) => {
  const list = [m.player1, m.player2, m.player1Name, m.player2Name].filter(Boolean);
  return list.includes(username);
}); 

    // const found = semifinalTables.find(
    //   (m) => m.player1 === username || m.player2 === username
    // );

    if (!found) return;

    // 💾 сохраняем всё нужное
    localStorage.setItem('username', username);
    localStorage.setItem('tableId', String(found.tableId));
    localStorage.setItem('gameType', gameType);

    const routeBase = gameType === 'long' ? 'longTournamentMatch' : 'tournamentMatch';
    const stage = isFinal ? 'ФИНАЛ' : 'ПОЛУФИНАЛ';

    console.log(`[client] переход в ${stage} →`, found);

    navigate(`/${routeBase}/${found.gameId}?tableId=${found.tableId}`);
  }

  tournamentSocket.on('tournament_semifinalsStarted', handleSemifinalsStarted);
  return () => {
    tournamentSocket.off('tournament_semifinalsStarted', handleSemifinalsStarted);
  };
}, [username, navigate]);




  // 6) Ловим финал
  useEffect(() => {
    function handleFinalStarted(data) {
      console.log('[client] Финал начался =>', data);
      
      localStorage.setItem('username', username);
      localStorage.setItem('tableId', String(data.finalTableId));


      if (data.player1 === username || data.player2 === username) {
        // navigate(`/tournamentMatch/${data.finalGameId}?tableId=${data.finalTableId}`);
        const routeBase = data.gameType === 'long' ? 'longTournamentMatch' : 'tournamentMatch';
        navigate(`/${routeBase}/${data.finalGameId}?tableId=${data.finalTableId}`);

      }
    }
    tournamentSocket.on('tournament_finalStarted', handleFinalStarted);
    return () => {
      tournamentSocket.off('tournament_finalStarted', handleFinalStarted);
    };
  }, [username, navigate]);


  useEffect(() => {
  function handleFinalStarted(data) {
    console.log('[client] Финал (LONG) начался =>', data);
    if (data.player1 === username || data.player2 === username) {
      navigate(`/longTournamentMatch/${data.finalGameId}?tableId=${data.finalTableId}`);
    }
  }

  tournamentSocket.on('long_tournament_finalStarted', handleFinalStarted);
  return () => {
    tournamentSocket.off('long_tournament_finalStarted', handleFinalStarted);
  };
}, [username, navigate]);



  // ---- Локальные коллбэки ----

  // Регистрация
//   const handleJoinTournament = (t) => {
//   if (!username) return alert(translate('tournament.authRequired'));
//   if (!t.gameType) return alert(translate('tournament.typeMissing'));

//   setSelectedTournament(t);
//   setShowPaymentModal(true);
// };

const handleJoinTournament = (t) => {
  if (!username) return alert(translate('tournament.authRequired'));

    // 👇 ВАЖНО: на мобильных регистрация полностью запрещена
  if (isMobile) {
    alert(translate('tournament.desktopOnly'));
    return;
  }


  if (!t.gameType) return alert(translate('tournament.typeMissing'));
  play('registerTournament').catch(() => {});
  setSelectedTournament({ ...t });   // новый объект => свежее состояние
  setShowPaymentModal(true);
};
 

const handlePaymentClose = () => {
  setShowPaymentModal(false);
  setSelectedTournament(null); // важно сбрасывать, чтобы не застревало
};

// === Избранный турнир (максимальный buyIn) и остальные ===
const { featuredTournament, otherTournaments } = useMemo(() => {
  if (!Array.isArray(tournaments) || tournaments.length === 0) {
    return { featuredTournament: null, otherTournaments: [] };
  }

  // Всегда работаем с числами (buyIn/prize могут прийти строками)
  const sorted = [...tournaments].sort((a, b) => {
    const buyA = Number(a.buyIn ?? a.buy_in) || 0;
const buyB = Number(b.buyIn ?? b.buy_in) || 0;

    if (buyB !== buyA) return buyB - buyA;

    // Если buyIn одинаковый — берём большее призовое
    const prizeA = Number(a.prize) || 0;
    const prizeB = Number(b.prize) || 0;
    return prizeB - prizeA;
  });

  return {
    featuredTournament: sorted[0],
    otherTournaments: sorted.slice(1),
  };
}, [tournaments]);



const renderTournamentCard = (t, { featured = false } = {}) => {
  if (!t) return null;

  const buyIn = Number(t.buyIn ?? t.buy_in ?? 0);
  const maxAmount = getMaxAmount(t);
  const isRegistered = isUserRegistered(t, username);
  const showBracket = showBracketForId === t.id;
  const st = String(t.status || '').toLowerCase();

  const registeredCount = Number.isFinite(t.registeredCount)
    ? t.registeredCount
    : (Array.isArray(t.registeredPlayers) ? t.registeredPlayers.length : 0);

  const maxPlayers = Number(t.maxPlayers) || 4;

  const imgSrc = pickImg(t, featured);

 return (
  <div
    className={`game-card ${featured ? 'featured' : 'mini-card'}`}
    key={`${t.id}${featured ? '-featured' : ''}`}
  >


      {/* === 1) КАРТИНКА — ОТДЕЛЬНЫЙ БЛОК === */}
      <div className="game-image-wrapper">
        <img
          src={imgSrc}
          alt={featured
            ? translate('tournament.imageAlt')
            : translate('tournament.buyInAlt', { amount: buyIn })}
          className={`game-image ${featured ? 'game-image--hero' : ''}`}
        />
      </div>

      {/* === 2) КОНТЕНТ — ВНЕ КАРТИНКИ (ВАЖНО!) === */}
      <div className="game-info">

        {featured ? (
          <>
            <h2 className="featured-title">
              <span>{translate('tournament.jackpot')}</span>
              <span>{translate('tournament.title')}</span>
            </h2>

            <div className="featured-max">
              <span className="featured-max__label">{translate('tournament.max')}</span>
              <span className="featured-max__amount">{translate('tournament.prize')} ${maxAmount}</span>
            </div>

            <p className="featured-players">
              {translate('tournament.registered', { count: registeredCount, max: maxPlayers })}
            </p>
          </>
        ) : (
          <>
            <h3 className="mini-title">
              <span>{translate('tournament.jackpot')}</span>
              <span>{translate('tournament.title')}</span>
            </h3>

            <div className="mini-max">
              <span className="mini-max__label">{translate('tournament.max')} </span>
              <span className="mini-max__amount">{translate('tournament.prize')} ${maxAmount}</span>
            </div>

            <p className="mini-players">
              {translate('tournament.registered', { count: registeredCount, max: maxPlayers })}
            </p>

            <div className="mini-buyin">
              <img className="mini-buyin__icon" src="/tiket.png" alt="" />
              <span className="mini-buyin__amount">${buyIn}</span>
            </div>
          </>
        )}

        {/* === КНОПКА / СТАТУС === */}
        {st === 'registration' ? (
  isRegistered ? (
    <button className="game-button" onClick={() => handleLeaveTournament(t)}>
      {translate('tournament.cancelRegistration')}
    </button>
  ) : (
    registeredCount < maxPlayers ? (
      <button
        className={`game-button ${featured ? 'featured-button register-gold' : 'mini-btn'}`}
        onClick={() => handleJoinTournament(t)}
        disabled={isMobile}
      >
        {isMobile
          ? translate('tournament.desktopOnlyShort')
          : translate('tournament.register')}
      </button>
    ) : (
      <div className="game-status">{translate('tournament.noSeats')}</div>
    )
  )
) : (
  <div className="game-status">
    {st === 'semifinal'
      ? translate('tournament.status.semifinal')
      : st === 'final'
      ? translate('tournament.status.final')
      : st === 'finished'
      ? translate('tournament.status.finished')
      : st.toUpperCase()}
  </div>
)}

        {/* {st === 'registration' ? (
          isRegistered ? (
            <button className="game-button" onClick={() => handleLeaveTournament(t)}>
              {translate('tournament.cancelRegistration')}
            </button>
          ) : (
            registeredCount < maxPlayers ? (
            <button
  className={`game-button ${featured ? 'featured-button register-gold' : 'mini-btn'}`}
  onClick={() => handleJoinTournament(t)}
>
  {translate('tournament.register')}
</button>

            ) : (
              <div className="game-status">{translate('tournament.noSeats')}</div>
            )
          )
        ) : (
          <div className="game-status">
            {st === 'semifinal'
              ? 'SEMIFINAL'
              : st === 'final'
              ? 'FINAL'
              : st === 'finished'
              ? 'FINISHED'
              : st.toUpperCase()}
          </div>
        )} */}

        {/* === BRACKET (если открыт) === */}
        {showBracket && (
          <div style={{ marginTop: '1rem' }}>
            <KnockoutScoreboard
              semiTopP1={t.semiTopP1 || ''}
              semiTopP2={t.semiTopP2 || ''}
              semiTopScore1={t.semiTopScore1 ?? 0}
              semiTopScore2={t.semiTopScore2 ?? 0}
              semiBotP1={t.semiBotP1 || ''}
              semiBotP2={t.semiBotP2 || ''}
              semiBotScore1={t.semiBotScore1 ?? 0}
              semiBotScore2={t.semiBotScore2 ?? 0}
              finalP1={t.finalP1 || ''}
              finalP2={t.finalP2 || ''}
              finalScore1={t.finalScore1 ?? 0}
              finalScore2={t.finalScore2 ?? 0}
              championName={t.championName || ''}
            />
          </div>
        )}
      </div>
    </div>
  );
};


// const renderTournamentCard = (t, { featured = false } = {}) => {
//   if (!t) return null;

//   // --- данные по турниру ---
//   // const buyIn = Number(t.buyIn) || 0;
//   const buyIn = Number(t.buyIn ?? t.buy_in ?? 0);

//   // const maxAmount = MAX_BY_BUYIN[buyIn] ?? (Number(t.prize) || 0);
//   const maxAmount = getMaxAmount(t);

//   // const isRegistered = Array.isArray(t.registeredPlayers)
//   //   ? t.registeredPlayers.some(p => p.username === username)
//   //   : false;
//   const isRegistered = isUserRegistered(t, username);

//   const showBracket = showBracketForId === t.id;
// const st = String(t.status || '').toLowerCase();

// const registeredCount = Number.isFinite(t.registeredCount)
//   ? t.registeredCount
//   : (Array.isArray(t.registeredPlayers) ? t.registeredPlayers.length : 0);

// const maxPlayers = Number(t.maxPlayers) || 4;
//   // --- фон карточки ---
//   // const imgSrc = featured
//   //   ? (t.bannerUrl || '/BigTournament.png')      // большой баннер
//   //   : (t.bgUrl || CARD_BG[buyIn] || '/img/blok.png'); // маленькие
// const imgSrc = pickImg(t, featured);

//   return (
//     <div className={`game-card ${featured ? 'featured' : ''}`} key={`${t.id}${featured ? '-featured' : ''}`}>
//       <div className="game-header">
//         {/* <span className="bet-price">${buyIn}</span> */}
//       </div>
// {/* <div style={{color:'#9aa3b2', fontSize:12, margin:'8px 0'}}>
//   long={longTournaments.length} | short={allTournaments.filter(t=>t.gameType==='short').length} | showing={tournaments.length}
// </div> */}

//       <div className="game-image-wrapper">
//         <img
//           src={imgSrc}
//           alt={featured ? 'Jackpot Tournament' : `Buy-in $${buyIn}`}
//           className={`game-image ${featured ? 'game-image--hero' : ''}`}
//         />

//         <div className="game-info">
//           {featured ? (
//             <>
//               <h2 className="featured-title">
//                 <span>{translate('tournament.jackpot')}</span>
//                 <span>{translate('tournament.title')}</span>
//               </h2>

//               <div className="featured-max">
//                 <span className="featured-max__label">{translate('tournament.max')}</span>
//                 <span className="featured-max__amount">{translate('tournament.prize')} ${maxAmount}</span>
//               </div>

//               <p className="featured-players">
//   {translate('tournament.registered', { count: registeredCount, max: maxPlayers })}
// </p>

//             </>
//           ) : (
//             <>
//               <h3 className="mini-title">
//                 <span>{translate('tournament.jackpot')}</span>
//                 <span>{translate('tournament.title')}</span>
//               </h3>

//               <div className="mini-max">
//                 <span className="mini-max__label">{translate('tournament.max')} </span>
//                 <span className="mini-max__amount">PRIZE  ${maxAmount}</span>
//               </div>
//              <p className="mini-players">
//   {translate('tournament.registered', { count: registeredCount, max: maxPlayers })}
// </p>


//               {/* билет + взнос на маленькой карточке (как в макете) */}
//               <div className="mini-buyin">
//                 <img className="mini-buyin__icon" src="/tiket.png" alt="" aria-hidden="true" />
//                 <span className="mini-buyin__amount">${buyIn}</span>
//               </div>
//             </>
//           )}
// {/* КНОПКА/СТАТУС ВНИЗУ СПРАВА */}
// {st === 'registration' ? (
//   isRegistered ? (
//     <button className="game-button" onClick={() => handleLeaveTournament(t)}>
//       {translate('tournament.cancelRegistration')}
//     </button>
//   ) : (
//     registeredCount < maxPlayers ? (
//       <button
//         className={`game-button ${featured ? 'featured-button register-gold' : ''}`}
//         onClick={() => handleJoinTournament(t)}
//         aria-label={featured ? `Register — $${buyIn}` : 'Регистрация'}
//       >
//         {translate('tournament.register')}
//       </button>
//     ) : (
//       <div className={`game-status ${featured ? 'game-status--hero' : ''}`}>МЕСТ НЕТ</div>
//     )
//   )
// ) : (
//   <div className={`game-status ${featured ? 'game-status--hero' : ''}`}>
//     {st === 'semifinal'
//       ? 'SEMIFINAL'
//       : st === 'final'
//       ? 'FINAL'
//       : st === 'finished'
//       ? 'FINISHED'
//       : st.toUpperCase()}
//   </div>
// )}

//           {/* {t.status === 'registration' ? (
//             isRegistered ? (
//               <button className="game-button" onClick={() => handleLeaveTournament(t)}>
//                 {translate('tournament.cancelRegistration')}
//               </button>
//             ) : (
//               t.registeredCount < t.maxPlayers ? (
//                 <button
//                   className={`game-button ${featured ? 'featured-button register-gold' : ''}`}
//                   onClick={() => handleJoinTournament(t)}
//                   aria-label={featured ? `Register — $${buyIn}` : 'Регистрация'}
//                 >
//                   {translate('tournament.register')}
//                 </button>
//               ) : (
//                 <p style={{ color: 'red' }}>Мест нет</p>
//               )
//             )
//           ) : (
//             <p style={{ color: 'red' }}>{String(t.status || '').toUpperCase()}</p>
//           )} */}

//           {featured && (
//             <div className="featured-buyin" title={`Взнос $${buyIn}`}>
//               <img className="featured-buyin__icon" src="/tiket.png" alt="" aria-hidden="true" />
//               <span className="featured-buyin__amount">${buyIn}</span>
//             </div>
//           )}

//         {/* {(t.status === 'semifinal' || t.status === 'final') && (
//         <div className="t-status-badge">
//           {t.status === 'semifinal' ? 'SEMIFINAL' : 'FINAL'}
//         </div>
//       )} */}

          

//           {showBracket && (
//             <div style={{ marginTop: '1rem' }}>
//               <KnockoutScoreboard
//                 semiTopP1={t.semiTopP1 || ''}
//                 semiTopP2={t.semiTopP2 || ''}
//                 semiTopScore1={t.semiTopScore1 ?? 0}
//                 semiTopScore2={t.semiTopScore2 ?? 0}
//                 semiBotP1={t.semiBotP1 || ''}
//                 semiBotP2={t.semiBotP2 || ''}
//                 semiBotScore1={t.semiBotScore1 ?? 0}
//                 semiBotScore2={t.semiBotScore2 ?? 0}
//                 finalP1={t.finalP1 || ''}
//                 finalP2={t.finalP2 || ''}
//                 finalScore1={t.finalScore1 ?? 0}
//                 finalScore2={t.finalScore2 ?? 0}
//                 championName={t.championName || ''}
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };


// const renderTournamentCard = (t, { featured = false } = {}) => {
//   if (!t) return null;

//   // Было у тебя в map — переносим сюда
//   const isRegistered = Array.isArray(t.registeredPlayers)
//     ? t.registeredPlayers.some(p => p.username === username)
//     : false;

//   const showBracket = showBracketForId === t.id;

//   return (
//     <div
//       className={`game-card ${featured ? 'featured' : ''}`}
//       key={`${t.id}${featured ? '-featured' : ''}`}
//     >
//       <div className="game-header">
//         <span className="bet-price">${t.buyIn}</span>
//       </div>

//       <div className="game-image-wrapper">
//        <img
//   src={
//     featured
//       ? (t.bannerUrl || '/BigTournament.png')  // большая картинка для баннера
//       : '/img/blok.png'                           // маленькие карточки
//   }
//   alt={featured ? 'Jackpot Tournament' : 'Game'}
//   className={`game-image ${featured ? 'game-image--hero' : ''}`}
// />


//         <div className="game-info">
//           {/* Заголовки: для большого баннера — крупный, для мелких — как было */}
//         {featured ? (
//   <>
//     <h2 className="featured-title">
//       <span>{translate('tournament.jackpot')}</span>
//       <span>{translate('tournament.title')}</span>
//     </h2>

//     <div className="featured-max">
//       <span className="featured-max__label">{translate('tournament.max')}</span>
//      <span className="featured-max__amount">${(featured && Number(t.buyIn) === 50) ? 5000 : t.prize}</span>

//     </div>
//   </>
// ) : (
//   // <p className="game-title">SIT AND GO&nbsp; {t.registeredCount}/{t.maxPlayers}</p>
//   <>
//   <h3 className="mini-title">
//     <span>{translate('tournament.jackpot')}</span>
//     <span>{translate('tournament.title')}</span>
//   </h3>

//   <div className="mini-max">
//     <span className="mini-max__label">MAX</span>
//     <span className="mini-max__amount">
//       ${Number(t.buyIn) === 50 ? 5000 : t.prize}
//     </span>
//   </div>
// </>
// )}


//                {featured ? (
//          <p className="featured-players">
//            Зарегистрировано {t.registeredCount}/{t.maxPlayers}
//          </p>
//        ) : (
//          <p className="prize">MAX PRIZE ${t.prize}</p>
//        )}


//           {t.status === 'registration' ? (
//             <>
//               {isRegistered ? (
//                 <button
//                   className="game-button"
//                   onClick={() => handleLeaveTournament(t)}
//                 >
//                   {translate('tournament.cancelRegistration')}
//                 </button>
//               ) : (
//                 <>
//                   {t.registeredCount < t.maxPlayers ? (
//                   <button
//                     className={`game-button ${featured ? 'featured-button register-gold' : ''}`}
//                     onClick={() => handleJoinTournament(t)}
//                     aria-label={featured ? `Register — $${t.buyIn}` : 'Регистрация'}
//                   >
//                     {translate('tournament.register')}
//                   </button>

//                   ) : (
//                     <p style={{ color: 'red' }}>Мест нет</p>
//                   )}
//                 </>
//               )}
//             </>
//           ) : (
//             <p style={{ color: 'red' }}>{t.status.toUpperCase()}</p>
//           )}

//         {featured && (
//           <div className="featured-buyin" title={`Взнос $${t.buyIn}`}>
//             <img
//               className="featured-buyin__icon"
//               src="/tiket.png"       // вставь сюда путь к своей картинке
//               alt=""                          // декоративная иконка
//               aria-hidden="true"
//             />
//             <span className="featured-buyin__amount">${t.buyIn}</span>
//           </div>
//         )}


//           {(t.status === 'semifinal' || t.status === 'final' || t.status === 'finished') && (
//             <button
//               className="game-button"
//               style={{ marginTop: '8px' }}
//               onClick={() => setShowBracketForId(showBracket ? null : t.id)}
//             >
//               {showBracket ? 'Скрыть турнирную сетку' : 'Показать турнирную сетку'}
//             </button>
//           )}

//           {showBracket && (
//             <div style={{ marginTop: '1rem' }}>
//               <KnockoutScoreboard
//                 semiTopP1={t.semiTopP1 || ''}
//                 semiTopP2={t.semiTopP2 || ''}
//                 semiTopScore1={t.semiTopScore1 ?? 0}
//                 semiTopScore2={t.semiTopScore2 ?? 0}
//                 semiBotP1={t.semiBotP1 || ''}
//                 semiBotP2={t.semiBotP2 || ''}
//                 semiBotScore1={t.semiBotScore1 ?? 0}
//                 semiBotScore2={t.semiBotScore2 ?? 0}
//                 finalP1={t.finalP1 || ''}
//                 finalP2={t.finalP2 || ''}
//                 finalScore1={t.finalScore1 ?? 0}
//                 finalScore2={t.finalScore2 ?? 0}
//                 championName={t.championName || ''}
//               />
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };




  // Отмена регистрации
const handleLeaveTournament = (t) => {
  if (!username) return alert(translate('tournament.authRequired'));
  if (!window.confirm(translate('tournament.cancelConfirm'))) return;
  const sock = t.gameType === 'long' ? longTournamentSocket : tournamentSocket;
  sock.emit('tournament_leaveTournament', {
    tournamentId: t.id,
    userName: username,
    gameType: t.gameType,
  });
};



const openPay = (t) => {
  // у «коротких» турниров gameType уже есть (short/long), просто сохраняем
  setSelectedTournament({ ...t });     // делаем новый объект
  setShowPaymentModal(true);
};

const closePay = () => {
  setShowPaymentModal(false);
  setSelectedTournament(null);
};


  // if (typeGame !== 0) return null;




  // ---- RENDER ----
  return (
  <div className="tournament-lobby">
    {showWheel && wheelData && (
      <SpinWheelOverlay
        angle={wheelData.angle}
        prize={wheelData.prize}
        buyIn={wheelData.buyIn}
        onClose={() => setShowWheel(false)}
      />
    )}

    {selectedTournament && (
      <TournamentPaymentModal
        open={showPaymentModal}
        tournament={selectedTournament}
        apiBase={selectedTournament.gameType === 'long' ? '/api/long-tournament' : '/api/tournament'}
        onClose={handlePaymentClose}
        onSuccess={(method) => {
  const sock = selectedTournament.gameType === 'long' ? longTournamentSocket : tournamentSocket;
  sock.emit('tournament_joinTournament', {
    tournamentId: selectedTournament.id,
    userName: username,
    gameType: selectedTournament.gameType,
    method,
  });

  // ⏱ обновим списки после успешной регистрации
  if (selectedTournament.gameType === 'long') {
    refreshLongTables?.();
  } else {
    refreshShortTables?.();
  }

  handlePaymentClose();
}}

        // onSuccess={(method) => {
        //   const sock = selectedTournament.gameType === 'long' ? longTournamentSocket : tournamentSocket;
        //   sock.emit('tournament_joinTournament', {
        //     tournamentId: selectedTournament.id,
        //     userName: username,
        //     gameType: selectedTournament.gameType,
        //     method,
        //   });
        //   handlePaymentClose();
        // }}
      />
    )}

    {/* Ряд №1 — правый столбец ВСЕГДА показываем */}
  <div className="jackpot-row">
  <div
    className={
      "jackpot-left" +
      (highlight ? " onboarding-highlight onboarding-highlight-pulse" : "")
    }
  >
    {featuredTournament
      ? renderTournamentCard(featuredTournament, { featured: true })
      : (
        <div className="game-card featured" style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:280,opacity:.8}}>
          <div style={{textAlign:'center'}}>
            <div style={{fontWeight:700, marginBottom:8,color:'#ffffffff',fontSize: 15}}>
              {translate('tournament.refreshPage')}
            </div>
          </div>
        </div>
      )
    }
  </div>

  <div className="jackpot-right">
    {rightSlot}
  </div>
</div>


    {/* Ряд №2 — «маленькие» карточки; если пусто — тоже даём заглушку */}
    {/* Ряд №2 — маленькие горизонтальные карточки */}
<div className="jackpot-row jackpot-row--small">

  {/* ЛЕВАЯ ЧАСТЬ — только мини-карточки */}
  <div
    className={
      "jackpot-left" +
      (highlight ? " onboarding-highlight onboarding-highlight-pulse" : "")
    }
  >
    {otherTournaments.length > 0 ? (
      <div className="game-cards small">
        {BOTTOM_TIERS.map(buy => {
          const t = otherTournaments.find(
            x => Number(x.buyIn ?? x.buy_in) === buy
          );
          return t ? renderTournamentCard(t, { featured: false }) : null;
        })}
      </div>
    ) : (
      <div style={{ padding: '16px 8px', color: '#fff', fontSize: 15 }}>
        {translate('tournament.refreshBrowser')}
      </div>
    )}
  </div>

  {/* ПРАВАЯ ЧАСТЬ — рейтинг (как было) */}
  <div className="jackpot-right">
    {ratingSlot}
  </div>

</div>


  </div>



  );
}

export default TournamentLobby;


